import { render, staticRenderFns } from "./NewPasswordRequired.vue?vue&type=template&id=56ae9c56"
import script from "./NewPasswordRequired.vue?vue&type=script&lang=js"
export * from "./NewPasswordRequired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports